package one.primehealth.app

import com.eygraber.uri.Uri
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.fetch.DEFAULT
import org.w3c.fetch.FOLLOW
import org.w3c.fetch.NO_CORS
import org.w3c.fetch.RequestCache
import org.w3c.fetch.RequestCredentials
import org.w3c.fetch.RequestInit
import org.w3c.fetch.RequestMode
import org.w3c.fetch.RequestRedirect
import org.w3c.fetch.Response
import org.w3c.fetch.SAME_ORIGIN


fun String.processDeepLink(): String? {
    val uri = Uri.parseOrNull(this)
    return uri?.query?.replace('=', '/')
}

suspend fun loadResource(file: String): ByteArray? {
    return fetch(file).arrayBuffer().await().asByteArray()
}

private suspend fun fetch(url: String): Response =
    window.fetch(
        input = url,
        init = RequestInit(
            method = "GET",
            headers = js("{}"),
            body = null,
            referrer = "",
            referrerPolicy = "no-referrer".asDynamic(),
            mode = RequestMode.NO_CORS,
            credentials = RequestCredentials.SAME_ORIGIN,
            cache = RequestCache.DEFAULT,
            redirect = RequestRedirect.FOLLOW,
            integrity = "",
            keepalive = false,
            window = null
        )
    ).await()

@Suppress("CAST_NEVER_SUCCEEDS")
fun ArrayBuffer?.asByteArray(): ByteArray? = this?.run { Int8Array(this) as ByteArray }